import { render, staticRenderFns } from "./VirtualFenceMap.vue?vue&type=template&id=132e190a"
import script from "./VirtualFenceMap.vue?vue&type=script&lang=js"
export * from "./VirtualFenceMap.vue?vue&type=script&lang=js"
import style0 from "./VirtualFenceMap.vue?vue&type=style&index=0&id=132e190a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports